define('time-zones',['require','i18next'],function (require) {
    var i18n = require('i18next');

    var timeZones = [
        {
            region: 'Pacific/Tongatapu',
            zone: i18n.t('web-timezones.Pacific/Tongatapu'),
            offset: '+13:00'
        },
        {
            region: 'Pacific/Fiji',
            zone: i18n.t('web-timezones.Pacific/Fiji'),
            offset: '+12:00'
        },
        {
            region: 'Pacific/Auckland',
            zone: i18n.t('web-timezones.Pacific/Auckland'),
            offset: '+12:00'
        },
        {
            region: 'Asia/Magadan',
            zone: i18n.t('web-timezones.Asia/Magadan'),
            offset: '+11:00'
        },
        {
            region: 'Australia/Currie',
            zone: '(GMT+11:00) Currie',
            offset: '+11:00'
        },
        {
            region: 'Asia/Vladivostok',
            zone: i18n.t('web-timezones.Asia/Vladivostok'),
            offset: '+10:00'
        },
        {
            region: 'Australia/Hobart',
            zone: i18n.t('web-timezones.Australia/Hobart'),
            offset: '+10:00'
        },
        {
            region: 'Pacific/Guam',
            zone: i18n.t('web-timezones.Pacific/Guam'),
            offset: '+10:00'
        },
        {
            region: 'Australia/Sydney',
            zone: i18n.t('web-timezones.Australia/Sydney'),
            offset: '+10:00'
        },
        {
            region: 'Australia/Brisbane',
            zone: i18n.t('web-timezones.Australia/Brisbane'),
            offset: '+10:00'
        },
        {
            region: 'Australia/Darwin',
            zone: i18n.t('web-timezones.Australia/Darwin'),
            offset: '+09:30'
        },
        {
            region: 'Australia/Adelaide',
            zone: i18n.t('web-timezones.Australia/Adelaide'),
            offset: '+09:30'
        },
        {
            region: 'Asia/Yakutsk',
            zone: i18n.t('web-timezones.Asia/Yakutsk'),
            offset: '+09:00'
        },
        {
            region: 'Asia/Seoul',
            zone: i18n.t('web-timezones.Asia/Seoul'),
            offset: '+09:00'
        },
        {
            region: 'Asia/Tokyo',
            zone: i18n.t('web-timezones.Asia/Tokyo'),
            offset: '+09:00'
        },
        {
            region: 'Asia/Taipei',
            zone: i18n.t('web-timezones.Asia/Taipei'),
            offset: '+08:00'
        },
        {
            region: 'Australia/Perth',
            zone: i18n.t('web-timezones.Australia/Perth'),
            offset: '+08:00'
        },
        {
            region: 'Asia/Singapore',
            zone: i18n.t('web-timezones.Asia/Singapore'),
            offset: '+08:00'
        },
        {
            region: 'Asia/Irkutsk',
            zone: i18n.t('web-timezones.Asia/Irkutsk'),
            offset: '+08:00'
        },
        {
            region: 'Asia/Shanghai',
            zone: i18n.t('web-timezones.Asia/Shanghai'),
            offset: '+08:00'
        },
        {
            region: 'Asia/Krasnoyarsk',
            zone: i18n.t('web-timezones.Asia/Krasnoyarsk'),
            offset: '+07:00'
        },
        {
            region: 'Asia/Bangkok',
            zone: i18n.t('web-timezones.Asia/Bangkok'),
            offset: '+07:00'
        },
        {
            region: 'Asia/Jakarta',
            zone: i18n.t('web-timezones.Asia/Jakarta'),
            offset: '+07:00'
        },
        {
            region: 'Asia/Rangoon',
            zone: i18n.t('web-timezones.Asia/Rangoon'),
            offset: '+06:30'
        },
        {
            region: 'Asia/Colombo',
            zone: i18n.t('web-timezones.Asia/Colombo'),
            offset: '+05:30'
        },
        {
            region: 'Asia/Dhaka',
            zone: i18n.t('web-timezones.Asia/Dhaka'),
            offset: '+06:00'
        },
        {
            region: 'Asia/Novosibirsk',
            zone: i18n.t('web-timezones.Asia/Novosibirsk'),
            offset: '+06:00'
        },
        {
            region: 'Asia/Katmandu',
            zone: i18n.t('web-timezones.Asia/Katmandu'),
            offset: '+05:45'
        },
        {
            region: 'Asia/Calcutta',
            zone: i18n.t('web-timezones.Asia/Calcutta'),
            offset: '+05:30'
        },
        {
            region: 'Asia/Karachi',
            zone: i18n.t('web-timezones.Asia/Karachi'),
            offset: '+05:00'
        },
        {
            region: 'Asia/Yekaterinburg',
            zone: i18n.t('web-timezones.Asia/Yekaterinburg'),
            offset: '+05:00'
        },
        {
            region: 'Asia/Kabul',
            zone: i18n.t('web-timezones.Asia/Kabul'),
            offset: '+04:30'
        },
        {
            region: 'Asia/Tbilisi',
            zone: i18n.t('web-timezones.Asia/Tbilisi'),
            offset: '+04:00'
        },
        {
            region: 'Asia/Muscat',
            zone: i18n.t('web-timezones.Asia/Muscat'),
            offset: '+04:00'
        },
        {
            region: 'Asia/Tehran',
            zone: i18n.t('web-timezones.Asia/Tehran'),
            offset: '+03:30'
        },
        {
            region: 'Africa/Nairobi',
            zone: i18n.t('web-timezones.Pacific/Tongatapu'),
            offset: '+03:00'
        },
        {
            region: 'Europe/Moscow',
            zone: i18n.t('web-timezones.Europe/Moscow'),
            offset: '+03:00'
        },
        {
            region: 'Asia/Kuwait',
            zone: i18n.t('web-timezones.Asia/Kuwait'),
            offset: '+03:00'
        },
        {
            region: 'Asia/Baghdad',
            zone: i18n.t('web-timezones.Asia/Baghdad'),
            offset: '+03:00'
        },
        {
            region: 'Asia/Jerusalem',
            zone: i18n.t('web-timezones.Asia/Jerusalem'),
            offset: '+02:00'
        },
        {
            region: 'Europe/Helsinki',
            zone: i18n.t('web-timezones.Europe/Helsinki'),
            offset: '+02:00'
        },
        {
            region: 'Africa/Harare',
            zone: i18n.t('web-timezones.Africa/Harare'),
            offset: '+02:00'
        },
        {
            region: 'Africa/Cairo',
            zone: i18n.t('web-timezones.Africa/Cairo'),
            offset: '+02:00'
        },
        {
            region: 'Europe/Bucharest',
            zone: i18n.t('web-timezones.Europe/Bucharest'),
            offset: '+02:00'
        },
        {
            region: 'Europe/Athens',
            zone: i18n.t('web-timezones.Europe/Athens'),
            offset: '+02:00'
        },
        {
            region: 'Africa/Malabo',
            zone: i18n.t('web-timezones.Africa/Malabo'),
            offset: '+01:00'
        },
        {
            region: 'Europe/Warsaw',
            zone: i18n.t('web-timezones.Europe/Warsaw'),
            offset: '+01:00'
        },
        {
            region: 'Europe/Brussels',
            zone: i18n.t('web-timezones.Europe/Brussels'),
            offset: '+01:00'
        },
        {
            region: 'Europe/Prague',
            zone: i18n.t('web-timezones.Europe/Prague'),
            offset: '+01:00'
        },
        {
            region: 'Europe/Amsterdam',
            zone: i18n.t('web-timezones.Europe/Amsterdam'),
            offset: '+01:00'
        },
        {
            region: 'GMT',
            zone: i18n.t('web-timezones.GMT'),
            offset: '0'
        },
        {
            region: 'Africa/Casablanca',
            zone: i18n.t('web-timezones.Africa/Casablanca'),
            offset: '0'
        },
        {
            region: 'Atlantic/Cape_Verde',
            zone: i18n.t('web-timezones.Atlantic/Cape_Verde'),
            offset: '-1:00'
        },
        {
            region: 'Atlantic/Azores',
            zone: i18n.t('web-timezones.Atlantic/Azores'),
            offset: '-01:00'
        },
        {
            region: 'America/Buenos_Aires',
            zone: i18n.t('web-timezones.America/Buenos_Aires'),
            offset: '-03:00'
        },
        {
            region: 'America/Sao_Paulo',
            zone: i18n.t('web-timezones.America/Sao_Paulo'),
            offset: '-03:00'
        },
        {
            region: 'America/St_Johns',
            zone: i18n.t('web-timezones.America/St_Johns'),
            offset: '-03:30'
        },
        {
            region: 'America/Santiago',
            zone: i18n.t('web-timezones.America/Santiago'),
            offset: '-04:00'
        },
        {
            region: 'America/Caracas',
            zone: i18n.t('web-timezones.America/Caracas'),
            offset: '-04:00'
        },
        {
            region: 'America/Halifax',
            zone: i18n.t('web-timezones.America/Halifax'),
            offset: '-04:00'
        },
        {
            region: 'America/Indianapolis',
            zone: i18n.t('web-timezones.America/Indianapolis'),
            offset: '-05:00'
        },
        {
            region: 'America/New_York',
            zone: i18n.t('web-timezones.America/New_York'),
            offset: '-05:00'
        },
        {
            region: 'America/Bogota',
            zone: i18n.t('web-timezones.America/Bogota'),
            offset: '-05:00'
        },
        {
            region: 'America/Mexico_City',
            zone: i18n.t('web-timezones.America/Mexico_City'),
            offset: '-06:00'
        },
        {
            region: 'America/Guatemala',
            zone: i18n.t('web-timezones.America/Guatemala'),
            offset: '-06:00'
        },
        {
            region: 'America/Chicago',
            zone: i18n.t('web-timezones.America/Chicago'),
            offset: '-06:00'
        },
        {
            region: 'America/Denver',
            zone: i18n.t('web-timezones.America/Denver'),
            offset: '-07:00'
        },
        {
            region: 'America/Phoenix',
            zone: i18n.t('web-timezones.America/Phoenix'),
            offset: '-07:00'
        },
        {
            region: 'America/Los_Angeles',
            zone: i18n.t('web-timezones.America/Los_Angeles'),
            offset: '-08:00'
        },
        {
            region: 'America/Anchorage',
            zone: i18n.t('web-timezones.America/Anchorage'),
            offset: '-09:00'
        },
        {
            region: 'Pacific/Honolulu',
            zone: i18n.t('web-timezones.Pacific/Honolulu'),
            offset: '-10:00'
        },
        {
            region: 'Pacific/Midway',
            zone: i18n.t('web-timezones.MIT'),
            offset: '-11:00'
        },
        {
            region: 'Europe/London',
            zone: i18n.t('web-timezones.Europe/London'),
            offset: '0'
        }
    ];

    return timeZones;
});

